import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import { LoggerModule } from "@vlinder-web/logger-module-react";
import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { VApplication } from "../../../application";

import {
  CREATE_TEMPLATE_COSTUME_FEATURE,
  UPDATE_TEMPLATE_COSTUME_FEATURE,
  DELETE_TEMPLATE_COSTUME_FEATURE,
} from "../graphql";

const log: any = LoggerModule?.getInstance();

export interface FeatureFormData {
  name?: string;
  code?: string;
  desc?: string;
  description?: string;
  alias?: string;
  featurePosition?: string | number;
  isSingleAttribute?: boolean;
  isVisible?: boolean;
  isMandatory?: boolean;
  isLabel?: boolean;
  images?: any[];
  costumeType?: string;
  template_costumeType?: string;
  [key: string]: any;
}

export interface CreateFeatureProps {
  formData?: FeatureFormData;
  [key: string]: any;
}

export interface UpdateFeatureProps {
  id: string;
  formData?: FeatureFormData;
  [key: string]: any;
}

export interface DeleteFeatureProps {
  id: string;
}

export interface IFeatureMethods extends IPluginMethodMap {
  createFeature(args: CreateFeatureProps): Promise<any>;
  updateFeature(args: UpdateFeatureProps): Promise<any>;
  deleteFeature(args: DeleteFeatureProps): Promise<any>;
}

const getGraphQLModule = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

const buildPayload = (args: CreateFeatureProps | UpdateFeatureProps) => {
  const raw = args?.formData ?? args ?? {};
  console.log(raw);
  return {
    template_costumeType: raw?.costumeType ?? raw?.template_costumeType,
    name: raw?.name,
    code: raw?.code,
    presentation: raw?.presentation,
    desc: raw?.description ?? raw?.desc,
    alias: raw?.alias,
    isCommon: raw?.isCommon,
    featurePosition: raw?.featurePosition,
    isSingleAttribute: raw?.isSingleAttribute === true,
    isVisible: raw?.isVisible === true,
    isMandatory: raw?.isMandatory === true,
    isLabel: raw?.isLabel === true,
    images: Array.isArray(raw?.images) ? raw?.images : [],
  };
};

export class FeatureService implements IAgentPlugin {
  readonly methods: IFeatureMethods;

  constructor() {
    this.methods = {
      createFeature: this.createFeature.bind(this),
      updateFeature: this.updateFeature.bind(this),
      deleteFeature: this.deleteFeature.bind(this),
    };
  }

  async createFeature(args: CreateFeatureProps) {
    log.blue("FeatureService.createFeature", args);

    const graphqlModule = getGraphQLModule();
    const client = graphqlModule.getClient("graphql-gateway");

    const res = await client.mutate({
      mutation: CREATE_TEMPLATE_COSTUME_FEATURE,
      variables: {
        data: buildPayload(args),
      },
      fetchPolicy: "no-cache",
    });

    return res?.data?.createCostumeFeature;
  }

  async updateFeature(args: UpdateFeatureProps) {
    log.blue("FeatureService.updateFeature", args);

    if (!args?.id) {
      throw new Error("ID not found for update");
    }

    const graphqlModule = getGraphQLModule();
    const client = graphqlModule.getClient("graphql-gateway");

    const res = await client.mutate({
      mutation: UPDATE_TEMPLATE_COSTUME_FEATURE,
      variables: {
        filter: {
          _id: args.id,
        },
        update: buildPayload(args),
      },
      fetchPolicy: "no-cache",
    });

    return res?.data?.updateCostumeFeature;
  }

  async deleteFeature(args: DeleteFeatureProps) {
    log.blue("FeatureService.deleteFeature", args);

    if (!args?.id) {
      throw new Error("Missing ID for delete");
    }

    const graphqlModule = getGraphQLModule();
    const client = graphqlModule.getClient("graphql-gateway");

    const res = await client.mutate({
      mutation: DELETE_TEMPLATE_COSTUME_FEATURE,
      variables: {
        filter: {
          _id: args.id,
        },
      },
      fetchPolicy: "no-cache",
    });

    return res?.data?.deleteCostumeFeature;
  }
}
